"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const gettext_1 = require("./gettext");
class CommonStore {
    constructor() {
        this.data = {};
        this.setData = (data = {}) => {
            this.data = data;
        };
        this.combineData = (data = {}) => {
            this.data = Object.assign(Object.assign({}, this.data), data);
        };
        this.gettext = (msgid, argArrs) => {
            const data = this.data;
            if (typeof data === "undefined") {
                return msgid;
            }
            return gettext_1.gettext(data, msgid, argArrs);
        };
    }
}
exports.CommonStore = CommonStore;
const getStore = (() => {
    let store;
    return function () {
        if (!store) {
            store = new CommonStore();
        }
        return store;
    };
})();
exports.commonStore = getStore();
//# sourceMappingURL=commonStore.js.map